import {
  TaxiCorporationUnbilledOrdersListItem,
  TaxiCorporationUnbilledOrdersListItemMissingBillings,
} from "../../../../../../common/services/taxi-corporation/unbilled/orders-list/taxi-corporation-unbilled-orders-list";
import BillingsTaxiUnbilledOrderListingItem, {
  BillingsTaxiUnbilledOrderListingItemMissingBillingType,
} from "../../common/types/billings-taxi-unbilled-order-listing-item";
import BillingsTaxiUnbilledOrderListingItemStatus from "../../common/types/billings-taxi-unbilled-order-listing-item-status";

const createListingItemStatus = (
  responseDataItem: TaxiCorporationUnbilledOrdersListItem,
): BillingsTaxiUnbilledOrderListingItemStatus => {
  if (responseDataItem.isCancelled) {
    return BillingsTaxiUnbilledOrderListingItemStatus.CANCELLED;
  }

  return BillingsTaxiUnbilledOrderListingItemStatus.FINISHED;
};

const createListingItemMissingBillingTypes = (
  responseItemMissingBillings: TaxiCorporationUnbilledOrdersListItemMissingBillings[],
): BillingsTaxiUnbilledOrderListingItemMissingBillingType[] => {
  const missingBillingTypes: BillingsTaxiUnbilledOrderListingItemMissingBillingType[] =
    [];

  if (
    responseItemMissingBillings.includes(
      TaxiCorporationUnbilledOrdersListItemMissingBillings.CARGO_TAXI,
    )
  ) {
    missingBillingTypes.push(
      BillingsTaxiUnbilledOrderListingItemMissingBillingType.CARGO_WITH_TAXI,
    );
  }

  return missingBillingTypes;
};

const createListingItem = (
  responseDataItem: TaxiCorporationUnbilledOrdersListItem,
): BillingsTaxiUnbilledOrderListingItem => {
  return {
    clientName: responseDataItem.client.name,
    dispatchName: responseDataItem.dispatch,
    driversDisplayNames: responseDataItem.drivers,
    externalOrderId: responseDataItem.externalId,
    internalOrderId: responseDataItem.humanId,
    passengers: responseDataItem.passengers,
    routeAddresses: responseDataItem.rideAddresses,
    startDate: responseDataItem.startTime,
    status: createListingItemStatus(responseDataItem),
    taxiCorporations: responseDataItem.taxiCorporations,
    uuid: responseDataItem.uuid,
    missingBillingTypes: createListingItemMissingBillingTypes(
      responseDataItem.missingTaxiBillings,
    ),
  };
};

const createListingItems = (
  responseDataItems: TaxiCorporationUnbilledOrdersListItem[],
): BillingsTaxiUnbilledOrderListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const billingsTaxiUnbilledOrderListingByTaxiFactory = {
  createListingItems,
};

export default billingsTaxiUnbilledOrderListingByTaxiFactory;
